import { Component, OnInit, Input, Output, forwardRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';

export const DATE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ImageCroppingComponent),
  multi: true
};

@Component({
  selector: 'app-image-cropping',
  templateUrl: './image-cropping.component.html',
  styleUrls: ['./image-cropping.component.scss'],
  providers: [DATE_VALUE_ACCESSOR]
})
export class ImageCroppingComponent implements OnInit {
 
  @Input() hiddenElem:boolean

  constructor() {      
  }

  imageChangedEvent: any = '';
  croppedImage: any = '';
  
  fileChangeEvent(event: any): void {    
      this.imageChangedEvent = event;
  }
  imageCropped(image: string) {
      console.log("image crooped ==>", image);
      this.croppedImage = image;      
  }
  imageLoaded() {
      // show cropper
  }
  loadImageFailed() {
      // show message
  }

  ngOnInit(){}

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/components/image-cropping/image-cropping.component.ts